/**
 * Adds the callback error code while preserving the return URL's existing query and fragment.
 */
export function createReturnUrlWithErrorCode(
    returnUrl: string,
    errorCode: string,
    baseUrl: string = window.location.origin
): string | null {
    try {
        const url = new URL(returnUrl, baseUrl);
        if (url.protocol !== "http:" && url.protocol !== "https:") {
            return null;
        }
        url.searchParams.set("errorCode", errorCode);
        return url.toString();
    } catch (error) {
        if (error instanceof TypeError) {
            return null;
        }
        throw error;
    }
}
